import formSaga from "./sagas/saga";

export default function (sagaMiddleware) {

    sagaMiddleware.run(formSaga);

}